export const categoryRoutes = {
  getCategories: '/category',
} as const;
